<template>
  <a-modal
    v-model="visible"
    width="720px"
    wrap-class-name="consult-form-modal"
    title="技术咨询"
    @cancel="cancel"
    @ok="onSubmit"
    okText="提交"
  >
    <div class="consult-form-modal-box">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          ref="consultTitle"
          label="咨询主题"
          prop="consultTitle"
        >
          <a-input
            v-model="form.consultTitle"
            placeholder="请输入咨询主题"
            @blur="
              () => {
                $refs.consultTitle.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="contactName" label="提交人" prop="contactName">
          <a-input
            v-model="form.contactName"
            placeholder="请填写提交人姓名"
            :max-length="4"
            @blur="
              () => {
                $refs.contactName.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="contactPhone"
          label="联系电话"
          prop="contactPhone"
        >
          <div style="display: flex; height: 40px; align-items: center">
            <a-input
              v-model="form.contactPhone"
              placeholder="请输入联系电话"
              :max-length="11"
              @blur="
                () => {
                  $refs.contactPhone.onFieldBlur();
                }
              "
            />
            <span class="send-mobile-code" v-if="is_contactPhoneCode">
              <v-count-down
                :trigger="() => sendMobileCode()"
                :phone="form.contactPhone"
              >
                <template #default>获取验证码</template>
                <template #loading="scope"
                  >{{ scope.seconds }}秒后重新发送</template
                >
              </v-count-down>
            </span>
          </div>
        </a-form-model-item>
        <a-form-model-item
          v-if="is_contactPhoneCode"
          ref="contactPhoneCode"
          label="短信验证码"
          prop="contactPhoneCode"
        >
          <a-input
            v-model="form.contactPhoneCode"
            placeholder="请输入短信验证码"
            @blur="
              () => {
                $refs.contactPhoneCode.onFieldBlur();
              }
            "
          >
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="所属单位" prop="contactCompany">
          <a-input v-model="form.contactCompany" placeholder="请输入所属单位" />
        </a-form-model-item>
        <a-form-model-item label="咨询详情" prop="consultDesc">
          <a-input
            v-model="form.consultDesc"
            placeholder="请输入您想咨询的详细内容"
            type="textarea"
            :auto-size="{ minRows: 4, maxRows: 4 }"
          />
        </a-form-model-item>
        <a-form-model-item label="附件" prop="annex">
          <upload-files
            file-type-code="9999"
            :isShowList="true"
            @success="uploadChange"
            @uploadRemove="uploadRemove"
            accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.rar,.zip"
            :maxNum="5"
            ref="uploadFiles"
          >
            <div style="display: flex">
              <a-button> <a-icon type="upload" /> 上传附件 </a-button>
              <p
                style="
                  font-size: 14px;
                  color: #999999;
                  line-height: 20px;
                  margin-left: 16px;
                "
              >
                支持上传doc/docx/xls/xlsx/ppt/pptx/pdf/rar/zip等文件，最多5个文件，且单个文件大小不超过20M
              </p>
            </div>
          </upload-files>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import VCountDown from "@/components/VCountDown";
import { getConsultCreate } from "@/api/news";
import { sendMobile } from "@/api/common";
import { mapGetters } from "vuex";
import uploadFiles from "@/components/uploadFiles";
export default {
  components: {
    VCountDown,
    uploadFiles,
  },
  props: ["show"],
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确!"));
      } else {
        callback();
      }
    };
    return {
      is_contactPhoneCode: true,
      visible: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      isCode: true,
      form: {
        consultTitle: "",
        consultDesc: "",
        contactName: "",
        contactPhone: "",
        contactPhoneCode: "",
        contactCompany: "",
        annex: [],
      },
      rules: {
        consultTitle: [
          { required: true, message: "请输入咨询主题", trigger: "blur" },
        ],
        contactName: [
          { required: true, message: "请输入提交人姓名", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        contactPhoneCode: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
        consultDesc: [
          {
            required: true,
            message: "请输入您想咨询的详细内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["isLogin", "userInfo"]),
  },
  watch: {
    show: function (val) {
      this.visible = val;
    },
  },
  mounted() {
    this.visible = this.show;
    if (this.isLogin) {
      this.form.contactPhone = this.userInfo.phone;
      this.$set(this.rules.contactPhoneCode[0], "required", false);
      this.is_contactPhoneCode = false;
      if (this.userInfo.realName) {
        this.form.contactName = this.userInfo.realName;
      }
    }
  },
  methods: {
    uploadChange(val) {
      this.form.annex.push(val.id);
    },
    uploadRemove(id) {
      for (let index = 0; index < this.form.annex.length; index++) {
        const element = this.form.annex[index];
        if (element === id) {
          this.form.annex.splice(index, 1);
        }
      }
    },
    sendMobileCode() {
      const { contactPhone } = this.form;
      sendMobile(contactPhone).then(() => {
        this.$message.success("发送成功！");
      });
    },
    onSubmit() {
      let { form } = this;
      let _this = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(form.annex,'form.annex-----')
          let data = {
            consultSource: "鸿联云",
            consultTitle: form.consultTitle,
            consultContent: form.consultDesc,
            contactDetail: form.contactPhone,
            contactPerson: form.contactName,
            consultAttmId: form.annex,
            contactCompany: form.contactCompany,
          };
          getConsultCreate(data).then((res) => {
            _this.$message.success("提交成功！");
            _this.$refs.ruleForm.resetFields();
            _this.$refs.uploadFiles.emptyList();
            _this.$emit("input", false);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancel() {
      this.$refs.uploadFiles.emptyList();
      this.visible = false;
      this.$emit("input", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.consult-form-modal-box {
  background: #fff;
  padding: 24px;
  > div {
    > form {
      background: #fff;
      padding: 24px;
    }
  }
}
.send-mobile-code {
  margin-left: 8px;
  padding: 0 16px;
  height: 32px;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    border-color: #f7392f;
    color: #f7392f;
  }
}
</style>
<style>
.consult-form-modal .ant-modal-body {
  padding: 0;
}
.consult-form-modal .ant-form-item {
  margin-bottom: 16px;
}
.consult-form-modal .ant-form-item:last-child {
  margin-bottom: 0;
}
</style>
